/**
 * POS-23112 -- the one opt-in for the embedded enterprise loyalty signup form's Google SSO.
 *
 * That form is framed, so `SocialLogin` opens SSO in a popup. The callback (`/oauth/social`, which
 * armageddon uses for Google as well as Apple) only hands the token back to the opener for a flow
 * marked `embeddedPopup=true` or opened from `/embedded-menu/` -- this route was neither, so the
 * popup logged itself in and navigated to this same signup form.
 *
 * Both ends of the handoff call this from the *opener*: the signup page marks the popup, and
 * `use-embedded-events` enables the matching storage receiver. One opener-side decision is what
 * keeps them in agreement -- the popup has no dispensary/enterprise context to evaluate the
 * rollout flag against.
 */

// The only URL the loyalty embed script frames (apps/api/src/embedded/loyalty/index.ts).
// `/enterprise/[enterpriseId]/signup` is excluded: that is the standalone enrollment link sent by
// QR codes and marketing emails, not an embed entrypoint.
const LOYALTY_SIGNUP_EMBED_ROUTE = '/stores/enterprise/[enterpriseId]/signup';

export type EmbeddedLoyaltySignupPopupFlowInput = {
  /** Next.js route pattern (`router.pathname`), not the resolved path. */
  pathname: string | undefined;
  /** `embed=1` is set on this page's query. */
  isEmbedMode: boolean;
  /** This page really is framed (`UI.isIframe`). */
  isIframe: boolean;
};

export const isEmbeddedLoyaltySignupPopupFlow = ({
  pathname,
  isEmbedMode,
  isIframe,
}: EmbeddedLoyaltySignupPopupFlowInput): boolean => isEmbedMode && isIframe && pathname === LOYALTY_SIGNUP_EMBED_ROUTE;
